import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Card from './Card';

export interface InterestProps {
    fontAwesomeIcon: IconProp;
    title: string;
    infos: string;
}

const Interest = (props: InterestProps) => {
    return (
        <div className="col-sm-12 col-md-4 mb-4">
            <Card icon={<FontAwesomeIcon icon={props.fontAwesomeIcon} />}>
                <h4 className="title">{props.title}</h4>
                <p className="description m-0">{props.infos}</p>
            </Card>
        </div>
    );
};

export default Interest;
